import punycode from 'punycode';

export const validateEmail = (email: string) => {
  const [local, domain] = email.split('@');
  if (!local || !domain) return false;

  let asciiDomain;
  try {
    asciiDomain = punycode.toASCII(domain);
  } catch (e) {
    return false;
  }

  const asciiEmail = `${local}@${asciiDomain}`;
  // Permite caracteres unicode en la parte local (ES SOLO PARA USO INTERNO, NO ESTÁ 100% ESTÁNDAR)
  const emailRegex =
    /^[\p{L}0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/u;

  return emailRegex.test(asciiEmail);
};
